import React from 'react';
export default function BatWingsSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Left wing - membrane with finger bones */}
      <path d="M18 18 L2 6 L6 16 L3 10 L8 18 L5 14 L10 20 L7 17 L14 24 Z" fill="#3A3A4A" />
      <path d="M18 18 L2 6 L6 16 L3 10 L8 18 L5 14 L10 20 L7 17 L14 24 Z" fill="#4A4A5C" opacity="0.5" />
      {/* Left wing membrane highlight */}
      <path d="M16 19 L4 8 L7 16 L10 20 Z" fill="#5C5C6E" opacity="0.3" />

      {/* Right wing - membrane with finger bones */}
      <path d="M22 18 L38 6 L34 16 L37 10 L32 18 L35 14 L30 20 L33 17 L26 24 Z" fill="#3A3A4A" />
      <path d="M22 18 L38 6 L34 16 L37 10 L32 18 L35 14 L30 20 L33 17 L26 24 Z" fill="#4A4A5C" opacity="0.5" />
      {/* Right wing membrane highlight */}
      <path d="M24 19 L36 8 L33 16 L30 20 Z" fill="#5C5C6E" opacity="0.3" />

      {/* Center body connection */}
      <ellipse cx="20" cy="22" rx="3" ry="5" fill="#2E2E3E" />

      {/* Cute eyes on the wing connection */}
      <circle cx="18" cy="20" r="1.2" fill="#FF4444" opacity="0.8" />
      <circle cx="22" cy="20" r="1.2" fill="#FF4444" opacity="0.8" />
      <circle cx="18" cy="19.5" r="0.4" fill="white" />
      <circle cx="22" cy="19.5" r="0.4" fill="white" />

      {/* Wing bone structure lines */}
      <path d="M18 18 L4 7" stroke="#2A2A3A" strokeWidth="0.8" strokeLinecap="round" />
      <path d="M18 18 L5 13" stroke="#2A2A3A" strokeWidth="0.6" strokeLinecap="round" />
      <path d="M18 18 L7 17" stroke="#2A2A3A" strokeWidth="0.5" strokeLinecap="round" />
      <path d="M22 18 L36 7" stroke="#2A2A3A" strokeWidth="0.8" strokeLinecap="round" />
      <path d="M22 18 L35 13" stroke="#2A2A3A" strokeWidth="0.6" strokeLinecap="round" />
      <path d="M22 18 L33 17" stroke="#2A2A3A" strokeWidth="0.5" strokeLinecap="round" />
    </svg>
  );
}
